import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press26',
  templateUrl: './notice-press26.component.html',
  styleUrls: ['./notice-press26.component.scss']
})
export class NoticePress26Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
